import { render } from "./2.TextAnimation.vue?vue&type=template&id=60d3680e&scoped=true"
import script from "./2.TextAnimation.vue?vue&type=script&lang=js"
export * from "./2.TextAnimation.vue?vue&type=script&lang=js"

import "./2.TextAnimation.vue?vue&type=style&index=0&id=60d3680e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d3680e"]])

export default __exports__